import type { ResumoChamado } from '../../../types/chamado'
import { CartaoDeChamado } from './CartaoDeChamado'
import { DESCRICAO_DA_LISTA } from './colunas'
import { TabelaDeChamados } from './TabelaDeChamados'

/**
 * A mesma página de resultados em duas formas: tabela no computador, cartões no telefone.
 *
 * A troca é por CSS e não por `matchMedia`, e isso é escolha: medir a largura em JavaScript faz a
 * página montar com a forma errada e trocar depois que o React roda — o cartão pisca e vira tabela
 * em toda visita. Com `hidden`, o navegador já entrega a forma certa no primeiro quadro, e o que
 * está escondido some também da árvore de acessibilidade: quem usa leitor de tela ouve uma lista,
 * não as duas.
 *
 * @param props as linhas da página corrente
 * @returns a tabela e os cartões, um visível de cada vez
 */
export function ListagemDeChamados({ itens }: { itens: ResumoChamado[] }) {
  return (
    <>
      <div className="hidden sm:block">
        <TabelaDeChamados itens={itens} />
      </div>

      <ul aria-label={DESCRICAO_DA_LISTA} className="space-y-3 sm:hidden">
        {itens.map((chamado) => (
          <CartaoDeChamado key={chamado.id} chamado={chamado} />
        ))}
      </ul>
    </>
  )
}
